import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const EmployeeInviteConfirmationDialog = ({ isOpen, onClose, email, onConfirm }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      
      PaperProps={{
        sx: {
          width: 500,
          borderRadius: 3,
          minHeight: 220,
        }
      }}
    >
      {/* Top content area with padding */}
      <Box sx={{ p: 2, pt: 1, position: 'relative' }}>
        {/* Close button */}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <DialogTitle sx={{ px: 0 }}>
          <Typography variant="h4" sx={{ fontWeight: 600 ,ml: 4}}>
            Send Invite
          </Typography>
        </DialogTitle>
      </Box>

      {/* Divider right after header */}
      <Divider />

      {/* Body content with padding */}
      <DialogContent sx={{ px: 3, py: 3 }}>
        <DialogContentText sx={{ fontSize: 16, color: 'text.primary' }}>
          Please confirm email address{' '}
          <Typography
            component="span"
            sx={{ color: '#23A26D', fontWeight: 600 }}
          >
            {email}
          </Typography>{' '}
          before we send the invite
        </DialogContentText>
      </DialogContent>

      {/* Footer with box shadow */}
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          px: 3,
          py: 3,
          boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.05)',
          backgroundColor: '#fff',
        }}
      >
        <Button variant="outlined" onClick={onClose} sx={{ minWidth: 100 }}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} color="main" sx={{ minWidth: 160 }}>
          Confirm & Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmployeeInviteConfirmationDialog;
